import { Component, Input, OnInit } from "@angular/core";
import { Tournament } from "../../../../../shared/models/tournament";
import { User } from "../../../../../shared/models/user";
import { TournamentStatus2 } from "../../../../../shared/enums/poker-types";
import { TableType } from "../../../../../shared/enums/table-type";

@Component({
  selector: "app-view-tournament-mobile-info-icons",
  templateUrl: "./view-tournament-mobile-info-icons.component.html",
  styleUrls: ["./view-tournament-mobile-info-icons.component.scss"],
})
export class ViewTournamentMobileInfoIconsComponent implements OnInit {
  @Input() tournament: Tournament;
  @Input() user: User;

  enumTournamentStatus2 = TournamentStatus2;
  enumTableType = TableType;

  constructor() {}

  ngOnInit(): void {}
}
